/**
 * Vendor Component
 * -----------------
 * displays vendor information
 *
 * props
 * -----------------
 * vendor - the vendor to display
 * linkToVendor - whether this should have a link to the vendor page
 * className - class styles
 */

import { type Vendor } from '../../types'
import Phone from '../modules/Phone'
import Link from './LinkOld'

type Props = JSX.IntrinsicElements['div'] & {
  vendor: Pick<Vendor, 'id' | 'accountNumbers' | 'contactName' | 'emailAddress' | 'phoneNumber'>
  linkToVendor?: boolean
}

const Vendor = ({ vendor, linkToVendor = false, className }: Props) => (
  <div className={className}>
    {linkToVendor ? (
      <Link to={`/vendors/${vendor.id}`}>{vendor.accountNumbers.join(', ')}</Link>
    ) : (
      <p>{vendor.accountNumbers.join(', ')}</p>
    )}
    {vendor.contactName && <p>{vendor.contactName}</p>}
    {vendor.emailAddress && <p>{vendor.emailAddress}</p>}
    {vendor.phoneNumber && <p>{Phone.format(vendor.phoneNumber)}</p>}
  </div>
)

export default Vendor
